export default {
  default: [
    {
      path: "/leningen",
      name: "loans.view",
      component: () => import("./views/LoansView.vue"),
      redirect: { name: "loans.overview" },
      children: [
        {
          path: "/leningen/overzicht",
          name: "loans.overview",
          component: () => import("./views/LoansOverviewView.vue"),
        },
        {
          path: "/leningen/uitbetalen",
          name: "loans.processor",
          component: () => import("./views/LoanProcessorView.vue"),
        },
        {
          path: "/leningen/in-gebreke",
          name: "loans.defaulting",
          component: () => import("./views/LoansDefaultingView.vue"),
        },
        {
          path: "/leningen/in-gebreke/:loanId",
          name: "loans.defaulting.loan",
          components: {
            default: () => import("./views/LoansDefaultingView.vue"),
            sideBar: () => import("@/modules/loans/views/LoanDetailPanelView.vue"),
          },
        },
      ],
    },
    {
      path: "/leningen/uitbetalen/klant/:id/lening",
      redirect: { name: "loans.processor" },
    },
    {
      path: "/leningen/uitbetalen/klant/:id/lening/:loanId",
      name: "loans.processor.loan",
      components: {
        default: () => import("./views/LoanProcessorView.vue"),
        sideBar: () => import("@/modules/loans/views/LoanDetailPanelView.vue"),
      },
    },
  ],
};
